<template>
  <button :class="{next}">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 12">
        <defs>
            <filter id="a" width="166.7%" height="225%" x="-33.3%" y="-50%" filterUnits="objectBoundingBox">
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
            </filter>
            <path id="b" d="m26.993 20.099-.01.055-.013.045c-.006.018-.011.037-.019.055l-.019.042a.99.99 0 0 1-.026.05l-.03.045a.76.76 0 0 1-.068.084l-.02.022-3.416 3.297a.741.741 0 0 1-.516.206.74.74 0 0 1-.516-.207.687.687 0 0 1 0-.995l2.17-2.094H12.73a.74.74 0 0 1-.516-.206.69.69 0 0 1-.09-.892.735.735 0 0 1 .606-.31h11.781l-2.17-2.094a.687.687 0 0 1 0-.996.748.748 0 0 1 1.031 0l3.416 3.296.06.067c.01.012.018.025.027.038a.624.624 0 0 1 .054.09l.017.033c.013.034.017.048.022.063.006.019.012.037.016.056l.007.044c.004.02.007.038.008.057V20.052l-.006.047Z"/>
        </defs>
        <g transform="translate(-9 -14)">
            <use fill="#000" filter="url(#a)" xlink:href="#b"/>
            <use xlink:href="#b"/>
        </g>
    </svg>
  </button>
</template>

<script>
export default {
  name: "ArrowButton",
  props: {
    next: Boolean,
  },
};
</script>

<style lang="scss" scoped>
button {
  background: rgba(0,0,0,0);
  border: none;
  border-radius: 100%;
  user-select: none;
  display: inline-block;
  width:40px;
  height:40px;
  display: grid;
  place-items: center;
  cursor: pointer;
  &.next svg {
      transform: scaleX(1);
  }
  @media (hover: hover) {
    transition: 0.2s all ease-in-out;
    &:hover {
      background: var(--light-grey);
      color: var(--grey);      
    }
  }
}
svg {
 transform: scaleX(-1);
  width: 100%;
  fill: var(--white);
}
</style>